import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type AuthorizedSignerDetailFragment = { __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, can_use_all_item_locations: boolean, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null, event_account: { __typename?: 'EventAccount', item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, can_be_deleted: boolean, event_account_id?: string | null }> | null } };

export const AuthorizedSignerDetailFragmentDoc = gql`
    fragment AuthorizedSignerDetail on AuthorizedSigner {
  id
  name
  event_account_id
  event_account_name
  allowed_item_locations {
    id
    name
  }
  can_use_all_item_locations
  event_account {
    item_locations {
      id
      name
      can_be_deleted
      event_account_id
    }
  }
}
    `;